import { IFilterResponsible } from "./types/responsibles"

export const units = [
    { text: "Unidade", value: "UN" },
    { text: "Quilograma", value: "KG" },
    { text: "Litro", value: "LT" },
    { text: "Metro", value: "MT" },
]

export const defaultFilterResponsible: IFilterResponsible = {
    name: '',
    doc: '',
    search: '',
}